export default {
  getCrewMember(state) {
    return {
      FirstName: state.FirstName,
      LastName: state.LastName,
      Email: state.Email,
      AddressLine1: state.AddressLine1,
      City: state.City,
      State: state.State,
      ZipCode: state.ZipCode,
      Phone: state.Phone,
      NewsletterOptIn: state.NewsletterOptIn,
      Year: state.YearLabel,
      Make: state.MakeLabel,
      Model: state.ModelLabel,
      Trim: state.TrimLabel,
      TireWidth: state.TireWidth,
      TireAspect: state.TireAspect,
      TireDiameter: state.TireDiameter,
      TireName: state.TireName,
      ShirtSize: state.ShirtSize,
      HatSize: state.HatSize,
      JacketSize: state.JacketSize,
      AdditionalInfo: state.AdditionalInfo,
    };
  },
  getUpdateCrewMember(state) {
    return {
      AdditionalInfo: state.AdditionalInfo,
      EnthusiastType: state.EnthusiastType,
      PublisherId: state.SessionId,
      Make: state.MakeLabel,
      Model: state.ModelLabel,
      TireName: state.TireName,
    };
  },
  getDeleteCrewMember(state) {
    const formData = new FormData();
    formData.append('PublisherId', state.SessionId);
    return formData;
  },
  getSessionId(state) {
    return {
      id: state.SessionId,
    };
  },
};
